var map = {
	"./desktop-phone-stack.png": "3336",
	"./desktop-tablet-stack.png": "e6b7",
	"./first-launch-1.png": "3de0",
	"./form-icons1.png": "4794",
	"./form-icons2.png": "0722",
	"./form-sent.png": "7151",
	"./main-banner.png": "3903",
	"./own-model.png": "b529",
	"./package.png": "1cce",
	"./phone-cadw.png": "e8c2",
	"./phone-folkentinget.png": "2ef1",
	"./phone-kolding.png": "1c2c",
	"./phone-stack1.png": "a0cf",
	"./phone-varde.png": "6fff",
	"./role-curator.png": "0e3b",
	"./role-develop-guides.png": "6d3a",
	"./role-director.png": "b19b",
	"./role-ecommerce.png": "183b",
	"./role-help-donations.png": "eda8",
	"./role-marketing.png": "4b35",
	"./role-membership.png": "3a59",
	"./role-story-teller.png": "0a0b",
	"./role-work-with-guides.png": "8d98",
	"./viz-in-holland.png": "7025"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8c98";